<template>
	<!-- <span>테스트</span> -->
	<!-- 테이블 사용시 sf-data-table을 사용 태그 안에 옵션들로 설정함 -->
	<sf-data-table
		ref="refTableInfoTable"
		:columns="columns"
		:rows="tableInfoList"
		:addRowDatas="addRowDatas"
		@row-eblclick="rowDblClick"
		@select="updateRef"
		cell-cass-name="content__cusror-pointer"
		:excel="isButton_(scrId, 'EX')"
		selection
		paging
		@changedPage="onChangePage"
		:pageUnit="pagingInfo.pageUnit"
		:pageArray="screen.pageArray"
		:totalSize="pagingInfo.totalSize || screen.defaultPageSize"
	>
		<template v-slot:actionsLeft>
			<sf-button line v-if="isButton_(scrId, 'AD')" icon="square-plue" :onClick="addAction">{{ getMessage_('MWCC000232') }}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'AD')" icon="file" :onClick="() => onClickButton('save')">{{
				getMessage_('MWCC000138')
			}}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'CD')" icon="trash" color="error" :onClick="() => onClickButton('delete')">{{
				getButtonMsg_(scrId, 'CD')
			}}</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { serviceComputed, serviceMethods } from '@qms/TableInfo/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
//import { rootComputed } from '@/store/helpers';

import * as yup from 'yup';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			addRowDatas: [],
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
		// console.log('tableView ::::' + this.scrId);
		// console.log('tableview screen ::', this.screen);
	},
	mounted() {
		// console.log('tableView_mount ::::' + this.scrId);
		const schema = () =>
			yup.object({
				tableName: yup
					.string()
					.trim()
					.default('')
					.required(this.$sf_formatString(this.getMessage_('MWCC000175'), [this.getMessage_('MWCC000519')]))
					.min(1, this.$sf_formatString(this.getMessage_('MWCC000176'), [this.getMessage_('MWCC000519'), 1]))
					.max(100, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('MWCC000519'), 100])),
				tbComment: yup
					.string()
					.trim()
					.default('')
					.required(this.$sf_formatString(this.getMessage_('MWCC000175'), [this.getMessage_('MWCC000520')]))
					.min(1, this.$sf_formatString(this.getMessage_('MWCC000176'), [this.getMessage_('MWCC000520'), 1]))
					.max(4000, this.$sf_formatString(this.getMessage_('MWCC000177'), [this.getMessage_('MWCC000520')])),
				useYn: yup.string().trim().default('Y')
			});

		this.SET({ key: 'schema', value: schema });
	},
	computed: {
		...serviceComputed,
		...rootComputed,
		rows() {
			return this.tableInfoList;
		},
		columns() {
			return [
				{ label: 'No.', prop: 'rnum', width: '50', sortable: false },
				{ label: this.getMessage_('MWCC000141'), prop: 'status', width: '90px' },
				{
					label: this.getMessage_('MWCC000538') /**테이블ID*/,
					prop: 'tableName',
					minWidth: '100px',
					form: {
						type: 'input',
						maxLength: 100
					},
					clickEvent: this.scrNameClick,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC000908') /**테이블 코맨트*/,
					prop: 'tbComment',
					minWidth: '150px',
					form: {
						type: 'input',
						maxLength: 100
					}
				},
				{
					label: this.getMessage_('QWCC000909') /**컬럼ID*/,
					prop: 'colName',
					minWidth: '100px',
					form: {
						type: 'input',
						maxLength: 100
					}
				},
				{
					label: this.getMessage_('QWCC000910') /**컬럼 코맨트*/,
					prop: 'colComment',
					minWidth: '150px',
					form: {
						type: 'input',
						maxLength: 100
					}
					// ,className: 'notification___nowrap'
				},
				{
					label: this.getMessage_('QWCC000911') /**데이터 타입*/,
					prop: 'dataType',
					minWidth: '100px',
					form: {
						type: 'input',
						maxLength: 100
					}
				},
				{
					label: this.getMessage_('QWCC000912') /**PK 여부*/,
					prop: 'pk',
					minWidth: '60px',
					form: {
						type: 'select',
						options: this.useYnOptions
					}
				},
				{
					label: this.getMessage_('QWCC000913') /**NULL 허용*/,
					prop: 'nullYn',
					minWidth: '60px',
					form: {
						type: 'select',
						options: this.useYnOptions
					}
				},
				{
					label: this.getMessage_('MWCC000407') /**비고*/,
					prop: 'rmk',
					minWidth: '100px',
					form: {
						type: 'input',
						maxLength: 4000
					}
				}
				// {
				// 	label: this.getMessage_('MWCC000145') /**사용유무*/,
				// 	prop: 'useYn',
				// 	form: {
				// 		type: 'select',
				// 		options: this.useYnOptions
				// 	},
				// 	width: '160px'
				// },
				// { label: this.getMessage_('MWCC000146') /**등록일*/, prop: 'displayRegDt', minWidth: '100px' },
				// { label: this.getMessage_('MWCC000005') /**등록자*/, prop: 'regId', width: '100px' },
				// { label: this.getMessage_('MWCC000171') /**수정일*/, prop: 'displayChgDt', minWidth: '100px' },
				// { label: this.getMessage_('MWCC000172') /**수정자*/, prop: 'chgId', width: '100px' }
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		addAction() {
			/* default Data가 없을경우 한행 추가 */
			// let addRowData = { ...this.addRowData };
			// this.rows.unshift(addRowData);
			// this.$refs.refTableInfoTable.getTable().toggleRowSelection(addRowData);

			/* default Data가 있을경우 make를 사용하여 추가 */
			this.makeAddDatas();
			let addRowData = { ...this.addRowDatas };
			this.rows.unshift(addRowData);
			this.$refs.refTableInfoTable.getTable().toggleRowSelection(addRowData);
		},
		getSelectedRows() {
			//const defaultObj = this.commCdTypeSchema.cast();
			const rows = this.$refs.refTableInfoTable.getSelectedRows().map(row => _(row).omitBy(_.isNull).omitBy(_.isUndefined).value());
			return rows;
		},
		makeAddDatas() {
			// 단건은  {} 이지만 다건은 [{},{}] 식으로 처리한다.
			this.addRowDatas = {
				status: 'I',
				tableName: '',
				tbComment: '',
				colName: '',
				colComment: '',
				dataType: '',
				pk: 'Y',
				nullYn: 'Y',
				rmk: ''
			};
		},
		// onClickRegister() {
		// 	this.setSelectedRow({ open: true });
		// },
		onChangePage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			/*
			console.log('currentPageVal :::::' + currentPageVal);
			console.log('pageUnitVal :::::' + pageUnitVal);
			console.log('prePage :::::' + prePage);
			console.log('prePageUnit :::::' + prePageUnit);
			*/
			if (!prePage || !prePageUnit) {
				return; //초기 중복 조회 방지.
			}
			this.$sf_toggleLoading(true);
			this.$store
				.dispatch('tableInfoStore/select_', { currentPage: currentPageVal, pageUnit: pageUnitVal })
				.finally(() => this.$sf_toggleLoading(false));
		},
		updateRef() {
			this.SET({ key: 'refTableInfoTable', value: this.$refs.refTableInfoTable });
		},
		rowDblClick(row, column, devent) {
			this.setSelectedRow({ ...row, open: true });
		},
		onClickButton(action) {
			if (this.getSelectedRows().length === 0) {
				this.$sf_showMessage({
					icon: 'error',
					message: this.getMessage_('MWCC000109')
				});
				return;
			}
			const messageCode = {
				save: 'MWCC000501',
				delete: 'MWCC000108'
			}[action];
			const clickFn = {
				save: this.update,
				delete: this.delete
			}[action];
			const message = this.getMessage_(messageCode);
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message,
				buttons: [{ title: 'Confirm', clickFn }] //this.getMessage_('MWCC000203')
			});
		},
		scrNameClick(row) {
			this.editRow = row;
			//this.$emit('PopupOpen');
			alert('popupOpen');
		}
	}
};
</script>

<style>
.content__cusror-pointer {
	cursor: pointer;
	user-select: none;
}
.notification___nowrap span {
	white-space: nowrap;
}
</style>
